import { GENERIC_OBJECT_READ } from "../../queries";
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
export default [{
  request: {
    query: GENERIC_OBJECT_READ,
    variables: MATCH_ANY_PARAMETERS
  },
  result: variables => {
    return {
      data: {
        genericObject_read: {
          name: variables === null || variables === void 0 ? void 0 : variables.objectId,
          activeFlag: false,
          __typename: 'GenericObjectDto'
        }
      }
    };
  }
}];